import { useRoutes } from 'react-router-dom';
import { DashboardRoutes } from "../packages/Dashboard/routes/DashboardRoutes";
import { HomeRoutes } from "../packages/Home/routes/HomeRoutes";
import { MidjourneyRoutes } from '../packages/Midjanouney/routes/MidjourneyRoutes';


let systemRoutes = [];
// home
systemRoutes.push(...HomeRoutes);

// dashboard routes
systemRoutes.push(...DashboardRoutes);

 
// midjourney route
MidjourneyRoutes.push(...MidjourneyRoutes)

 
 

export default function Router() {
  return useRoutes(systemRoutes);
}